import { FORM_STATUS, FIELD_STATUS, API_CALL_STATUS } from '../status';
import {
    EMAIL_SET_VALUE,
    EMAIL_SET_VALID,
    OTP_SET_VALUE,
    OTP_SET_VALID,
    LOGIN_FAILURE,
    LOGIN_SUCCESS,
    API_PENDING_LOGIN,
    API_FAILURE_LOGIN,
    API_SUCCESS_LOGIN,
    API_PENDING_AUTH_LOGIN,
    API_FAILURE_AUTH_LOGIN,
    API_SUCCESS_AUTH_LOGIN,
    AUTH_LOGIN_SUCCESS,
    AUTH_LOGIN_FAILURE,
    API_INITIAL_VERIFY,
    API_PENDING_VERIFY,
    API_FAILURE_VERIFY,
    API_SUCCESS_VERIFY,
    VERIFY_SUCCESS,
    VERIFY_FAILURE,
    SHOW_OTP_SCREEN_VALUE,
    SHOW_OTP_SCREEN_VALID,
    REINITIALIZE,
} from '../../actions/eaTravelRates/auth';

export const initAuth = {
    formStatus: FORM_STATUS.INVALID,
    loginApiCallStatus: null,
    loginData: null,
    authLoginApiCallStatus: null,
    authLoginData: null,
    verifyApiCallStatus: null,
    verifyData: null,
    form: {
        email: { value: null, error: null, status: null },
        otp: { value: null, error: null, status: null },
        showOtpScreen: { value: false, error: null, status: null },
    },
};

export default (state = initAuth, action) => {
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });

    switch (action.type) {
        case EMAIL_SET_VALUE:
            return updateFormField('email', (field) => ({
                ...field,
                value: action.value,
            }));
        case EMAIL_SET_VALID:
            return updateFormField('email', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case OTP_SET_VALUE:
            return updateFormField('otp', (field) => ({
                ...field,
                value: action.value,
            }));
        case OTP_SET_VALID:
            return updateFormField('otp', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case SHOW_OTP_SCREEN_VALUE:
            return updateFormField('showOtpScreen', (field) => ({
                ...field,
                value: action.value,
            }));
        case SHOW_OTP_SCREEN_VALID:
            return updateFormField('showOtpScreen', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case API_PENDING_LOGIN:
            return { ...state, loginApiCallStatus: API_CALL_STATUS.PENDING };

        case API_SUCCESS_LOGIN:
            return { ...state, loginApiCallStatus: API_CALL_STATUS.SUCCESS };

        case API_FAILURE_LOGIN:
            return { ...state, loginApiCallStatus: API_CALL_STATUS.FAILURE };

        case LOGIN_SUCCESS:
            return { ...state, loginData: action.data };

        case LOGIN_FAILURE:
            return { ...state, loginData: null };

        case API_PENDING_AUTH_LOGIN:
            return { ...state, authLoginApiCallStatus: API_CALL_STATUS.PENDING };

        case API_SUCCESS_AUTH_LOGIN:
            return { ...state, authLoginApiCallStatus: API_CALL_STATUS.SUCCESS };
        case API_FAILURE_AUTH_LOGIN:
            return { ...state, authLoginApiCallStatus: API_CALL_STATUS.FAILURE };

        case AUTH_LOGIN_SUCCESS:
            return { ...state, authLoginData: action.data };

        case AUTH_LOGIN_FAILURE:
            return { ...state, authLoginData: null };

        case API_INITIAL_VERIFY:
            return { ...state, verifyApiCallStatus: null };

        case API_PENDING_VERIFY:
            return { ...state, verifyApiCallStatus: API_CALL_STATUS.PENDING };

        case API_SUCCESS_VERIFY:
            return { ...state, verifyApiCallStatus: API_CALL_STATUS.SUCCESS };
        case API_FAILURE_VERIFY:
            return { ...state, verifyApiCallStatus: API_CALL_STATUS.FAILURE };

        case VERIFY_SUCCESS:
            return { ...state, verifyData: action.data };

        case VERIFY_FAILURE:
            return { ...state, verifyData: null };

        case REINITIALIZE:
            return initAuth;

        default:
            return state;
    }
};
